import { render, staticRenderFns } from "./ComboboxRegional.vue?vue&type=template&id=0455ab37&"
import script from "./ComboboxRegional.vue?vue&type=script&lang=js&"
export * from "./ComboboxRegional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports